import { isCypressRun } from '~/utils/PathUtils';
import { isLocal, isUnitTest } from '~/utils/Url';

export const getAnalyticsAreDisabled = () => isLocal() || isCypressRun() || isUnitTest();
